import angular from 'angular';

(function() {
    'use strict';
    angular.module('depositorconfirm').factory('DepositorConfirm', DepositorConfirmData);

    DepositorConfirmData.$inject = ['$translate'];

    /* @ngInject */
    function DepositorConfirmData($translate) {
        DepositorConfirm.prototype = {
            build: build,
            getSpammerLabel: getSpammerLabel
        };

        function DepositorConfirm(depositorConfirmData) {
            if (depositorConfirmData) {
                this.build(depositorConfirmData);
            }
        }

        return DepositorConfirm;

        /////////////////////

        function build(depositorConfirmData) {
            this.depositorId = depositorConfirmData.depositorId || null;
            this.email = depositorConfirmData.email || null;
            this.name = depositorConfirmData.name || null;
            this.antispamDate = depositorConfirmData.antispamDate || null;
            this.envelopeCount = depositorConfirmData.envelopeCount || null;
            this.spammer = depositorConfirmData.spammer || null;
        }

        function getSpammerLabel() {
            return this.spammer ? $translate.instant('YES') : $translate.instant('NO');
        }
    }
})();
